<div class="row page-header">
    <div class="col-12">
        <h1>Attendee Sign-in <small>Would you like to join the meeting?</small></h1>
    </div>
</div>
<div style="display: flex; flex-direction: column; gap: 15px; padding: 10px 0" [hidden]="message">
    <button class="btn btn-primary" (click)="register()">Yes</button>
    <button class="btn btn-secondary" (click)="decline()">No</button>
</div>
<div [hidden]="!message">
    {{ message }}
</div>
